import React from "react";
import { Redirect, useParams } from "react-router-dom";
//
import { Box, CircularProgress } from "@material-ui/core";
import { LiveHelp as LiveHelpIcon } from "@material-ui/icons";
//
import MenuLink from "containers/components/menuItem/MenuLink";

function ProtectedFAQCategory({ categories, redirectPath = "/unauthorized", children }) {
    const { id } = useParams();
    const categoryId = parseInt(id);

    if (categories === undefined) {
        return (
            <Box sx={{ marginLeft: "auto", marginRight: "auto", width: "fit-content" }}>
                <CircularProgress color="primary" />
            </Box>
        );
    }

    if (!categories.find((category) => category.id === categoryId)) {
        return (
            <Redirect
                to={{
                    pathname: redirectPath,
                    state: {
                        unauthorized: true,
                        redirectBackElement: <MenuLink to="/help" name="FAQ" icon={<LiveHelpIcon />} />,
                    },
                }}
            />
        );
    }

    return <>{children}</>;
}

export default ProtectedFAQCategory;
